import { z } from 'zod'
export enum UserTrialSetupStepEnum {
   orgSetup = 'org-setup',
   almostThere = 'almost-there',
   completed = 'completed'
}
export const userTrialSetupStepSchema = z.nativeEnum(UserTrialSetupStepEnum)
export type UserTrialSetupStepSchema = z.infer<typeof userTrialSetupStepSchema>
